module.exports = __webpack_public_path__ + "img/bg.a97b1ed6.png";